/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { AppHeader } from "./AppHeader";

/**
 * Renders the navbar component with a sign-in or sign-out button depending on whether or not a user is authenticated
 * @param props 
 */
export const PageLayout = (props) => {
    return (
        <> 
            <div className="w-75 mx-auto p-2 h-100">
                <header className="mb-2">
                    <AppHeader />
                </header>
                <main role="main" >
                    {props.children}
                </main>
                <footer >
                </footer>
            </div>
        </>
    );
};
